/*
 * Project: bellcloud
 * File: packages/types/device/log_data_type.ts
 * Author: SWAN
 * Created: 2025-07-21 18:15:27
 * Description:
 */

export enum FileType {
  GAS = 0,
  EVENT = 1,
  GEN_CONF = 2,
  SEN_CONF = 3,
  GAS_ALARM = 4,
  CAL_BUMP = 5,
  DATALOG = 99,
}
